export type AdditionalRule = 'untenanted' | 'nearCusp' | 'conjunctions' | 'aspects';
export const ADDITIONAL_RULES: AdditionalRule[] = ['untenanted', 'nearCusp', 'conjunctions', 'aspects'];
export const DEFAULT_ADDITIONAL_RULES: Record<AdditionalRule, boolean> = {
  untenanted: false, nearCusp: false, conjunctions: false, aspects: false,
};
export type FourthRow = 'none' | 'starOfSubLord' | 'subSubLord';
export const ORB_CHOICES = [1, 2, 10 / 3, 5, 10];
export const planetKey = (name: string) => String(name || '').toUpperCase();
export const rotateAdditionalHouse = (house: number, rotation = 1) => ((house - rotation + 12) % 12) + 1;

// Baseline rows are the same already-rendered Nadi rows, including node representation
// and house rotation. Only the new connection/evidence houses need rotating here.
export function additionalGroups(data: any, nadiRows: any[], rotation = 1, fourth: FourthRow = 'none') {
  const byPlanet = Object.fromEntries((data?.planets || []).map((p: any) => [planetKey(p.planet), p])) as Record<string, any>;
  const nadiByPlanet = Object.fromEntries(nadiRows.map(row => [planetKey(row.planet), row]));
  const rows = nadiRows.length ? nadiRows : (data?.planets || []).map((p: any) => ({
    planet: p.planet, starLord: p.starLord, subLord: p.subLord,
    planetSigs: p.directHouses.map((h: number) => rotateAdditionalHouse(h, rotation)),
    starLordSigs: byPlanet[planetKey(p.starLord)].directHouses.map((h: number) => rotateAdditionalHouse(h, rotation)),
    subLordSigs: byPlanet[planetKey(p.subLord)].directHouses.map((h: number) => rotateAdditionalHouse(h, rotation)),
  }));
  return rows.map((row: any) => {
    const root = byPlanet[planetKey(row.planet)];
    if (!root) return null;
    const definitions = [
      { level: 'planet', name: row.planet, houses: row.planetSigs, occupied: row.currentHouse },
      { level: 'starLord', name: row.starLord, houses: row.starLordSigs, occupied: row.starLordCurrentHouse },
      { level: 'subLord', name: row.subLord, houses: row.subLordSigs, occupied: row.subLordCurrentHouse },
    ];
    if (fourth !== 'none') {
      const name = root[fourth];
      const original = nadiByPlanet[planetKey(name)];
      definitions.push({ level: fourth, name, houses: original?.planetSigs || byPlanet[planetKey(name)]?.directHouses.map((h: number) => rotateAdditionalHouse(h, rotation)),
        occupied: original?.currentHouse || rotateAdditionalHouse(byPlanet[planetKey(name)].occupiedHouse, rotation) });
    }
    return { root, levels: definitions.map(def => ({ ...def, connection: byPlanet[planetKey(def.name)] })) };
  }).filter(Boolean) as { root: any; levels: { level: string; name: string; houses: number[]; occupied?: number; connection: any }[] }[];
}

export function selectedAdditionalEvidence(connection: any, rules: Record<AdditionalRule, boolean>) {
  return (connection?.evidence || []).filter((e: any) => rules[e.rule as AdditionalRule]);
}
